<template>
  <div>
    <Popper placement="right" :show="openedPopperEditableCommentId === mutableComment.id">
      <button class="btn btn-primary" @click="openedPopperEditableCommentId = mutableComment.id"> Edytuj komentarz </button>
      <template #content>
        <div>
          <button class="btn btn-sm btn-danger d-block w-100 mb-2" @click="openedPopperEditableCommentId = null">
            Zamknij edytor <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div :key="comment.id">
          <form @submit.prevent="UpdateComment">
            <div style="width: 300px;">
              <input type="text" class="form-control" v-model="mutableComment.title" placeholder="Tytuł">
              <textarea class="form-control mr-3" v-model="mutableComment.content" placeholder="Treść" style="margin-top: 5px;"></textarea>
              <div class="text-sm mt-2 user-select-none">
                Kolor tekstu etykiety
                <div>
                  <span
                    @click="mutableComment.textColor = color"
                    v-for="color in colors"
                    :key="color"
                    role="button"
                    class="mx-1 px-1"
                    :style="color === mutableComment.textColor ? `height: 20px; width: 20px; background-color: ${color}; color: ${color}; border: 3px solid black;` : `height: 20px; width: 20px; background-color: ${color}; color: ${color}; border: 1px solid black;`"
                  ></span>
                </div>
              </div>
              <div class="text-sm mt-2 user-select-none" role="button">
                Kolor tła etykiety
                <div>
                  <span
                    @click="mutableComment.backgroundColor = color"
                    v-for="color in colors"
                    :key="color"
                    role="button"
                    class="mx-1 px-1"
                    :style="color === mutableComment.backgroundColor ? `height: 20px; width: 20px; background-color: ${color}; color: ${color}; border: 3px solid black;` : `height: 20px; width: 20px; background-color: ${color}; color: ${color}; border: 1px solid black;`"
                  ></span>
                </div>
              </div>

              Wyślij przypomnienie:
              <input type="date" class="form-control" ref="selectedDate" v-model="mutableComment.sendNotificationOn">
              Wypisz maile po przecinku:
              <input type="text" class="form-control" v-model="mutableComment.mailNotificationRecipients" placeholder="Maile">

              <Popper placement="right" >
                <span role="button" class="btn btn-success mt-1">
                  Wybierz maile z bazy
                </span>
                <template #content>
                  <div v-for="m in mailings" :key="m.id" role="button" @click="AddMail(m.value)" style="width: 350px">
                    {{ m.value }} -> {{ m.name }}
                  </div>
                </template>
              </Popper>

              <div style="text-align: center;">
                <button class="btn btn-primary" style="margin-top: 5px; padding: 5px;">
                  Edytuj komentarz
                </button>
              </div>
            </div>
          </form>
        </div>
      </template>
    </Popper>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Popper from 'vue3-popper'
import colors from '@/modules/cells/colors'
import emitter from '@/modules/events/emitter'
import { $axios } from '@/modules/http/axios'

export default {
  components: { Popper },
  props: ['comment'],
  data () {
    return {
      colors: colors,
      mutableComment: this.comment,
      openedPopperEditableCommentId: null
    }
  },
  computed: {
    mailings () {
      return this.$store.getters.getCalendarMailings
    }
  },
  mounted () {
    this.mutableComment.mailNotificationRecipients = ''
    this.InitMails()
  },
  methods: {
    UpdateComment () {
      let array = []

      if (this.mutableComment?.mailNotificationRecipients?.includes(',')) {
        array = this.mutableComment?.mailNotificationRecipients?.split(',')
      }

      const putData = this.mutableComment
      putData.mailNotificationRecipients = array

      $axios.put(`Comment/${this.mutableComment.id}`, putData)
        .then(() => {
          this.openedPopperEditableCommentId = null
          Swal.fire('Sukces', 'Edycja przeszła pomyślnie', 'success')
          emitter.emit('calendarVehicleChanged')
          if (this.$parent.$options.name === 'ShowCellCommentModal') {
            emitter.emit('planCommentAdded')
          }
        }).catch((e) => {
          Swal.fire('Błąd', 'Coś poszło nie tak', 'error')
          console.log(e)
        })
    },
    AddMail (mail) {
      this.mutableComment.mailNotificationRecipients += mail + ','
    },
    InitMails () {
      this.mutableComment.notification?.recipients?.forEach(Element => {
        this.mutableComment.mailNotificationRecipients += Element + ','
      })

      if (this.mutableComment.notification?.sendDate) {
        this.mutableComment.sendNotificationOn = this.mutableComment.notification?.sendDate.split('T')[0]
      } else {
        this.mutableComment.sendNotificationOn = this.mutableComment.notification?.plannedSendDate?.split('T')[0]
      }
    }
  }
}
</script>
